export class LatLng {
    lat: number
    lng: number
}



// WEBPACK FOOTER //
// ./src/types/LatLng.ts